import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Home section styled components
export const HomeSection = styled(Box)({
  position: 'relative',
  zIndex: -1,
  backgroundPosition: 'top center',
  backgroundRepeat: 'no-repeat',
  paddingBottom: '30px',
  paddingTop: '30px',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
});

export const HomeContent = styled(Box)(({ theme }) => ({
  padding: '9rem 0 2rem',
  color: 'whitesmoke',
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const HomeHeader = styled(Box)({
  paddingTop: '80px',
});

// Typewriter wrapper
export const TypewriterWrapper = styled(Box)(({ theme }) => ({
  fontSize: '1em',
  color: '#be6adf',
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: '1.4em',
    fontWeight: 500,
    position: 'absolute',
  },
}));

export const TypewriterCursor = styled(Box)(({ theme }) => ({
  fontSize: '2.4em',
  color: '#b562d6',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

// Wave animation for emoji
export const WaveEmoji = styled('span')({
  animationName: 'wave-animation',
  animationDuration: '2.1s',
  animationIterationCount: 'infinite',
  transformOrigin: '70% 70%',
  display: 'inline-block',
});

// Home about section
export const HomeAboutSection = styled(Box)({
  position: 'relative',
  paddingBottom: '70px',
  paddingTop: '70px',
});

export const HomeAboutDescription = styled(Typography)({
  color: 'white',
  paddingTop: '100px',
  paddingBottom: '20px',
  textAlign: 'center',
});

export const HomeAboutBody = styled(Typography)({
  paddingTop: '50px',
  fontSize: '1.2em',
  textAlign: 'left',
});

export const HomeAboutSocial = styled(Box)({
  textAlign: 'center',
  paddingTop: '25px',
  color: 'white',
});

export const HomeAboutSocialLinks = styled(Box)({
  justifyContent: 'center',
  paddingTop: '15px',
  display: 'inline-block',
  position: 'relative',
  paddingInlineStart: 0,
});

export const HomeSocialIcons = styled(Box)({
  position: 'relative',
  display: 'inline-block',
  width: '40px',
  height: '40px',
  textAlign: 'center',
  fontSize: '1.2em',
  lineHeight: '2em',
  background: 'rgba(255, 255, 255, 0.972)',
  borderRadius: '50%',
  transition: '0.5s',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    background: '#68187a',
    transition: '0.5s',
    transform: 'scale(0.9)',
    zIndex: -1,
  },
  '&:hover::before': {
    transform: 'scale(1.1)',
    boxShadow: '0 0 15px #801f95',
  },
  '&:hover': {
    color: '#87209e',
    boxShadow: '0 0 5px #87209e',
    textShadow: '0 0 2px #87209e',
  },
});

export const SocialIcons = styled(Box)({
  display: 'inline-block',
  paddingRight: '15px',
  paddingLeft: '15px',
});

export const IconColour = styled(Box)({
  color: '#700c86',
});

// My avatar styles
export const MyAvatar = styled(Box)(({ theme }) => ({
  justifyContent: 'center',
  paddingTop: '9em',
  [theme.breakpoints.down('md')]: {
    paddingTop: '2em',
    paddingBottom: '2em',
  },
}));
